// extracted by mini-css-extract-plugin
export default {"select":"ChooseLanguagePage_select__mqMRm"};